import { useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Box, Button, ButtonIcon, IconClose } from '@machobear/design-system'

import { Label } from '@/components/text'
import useOnClickOutside from '@/components/use-onclick-outside'

import BathRadioBar from '../bath-radio-bar'
import BedRadioBar from '../bed-radio-bar'
import { FilterWrapper } from '../elements'

const StyledFilterWrapper = styled(FilterWrapper)`
  width: fit-content;
  margin-top: 8px;
  ${props => props.isExt && 'right: 0;'}
`

const BedBathFilter = ({
  value,
  onChange,
  clickOutsideCallback = () => {},
  close,
  disableBed,
  isExt
}) => {
  const { t } = useTranslation()
  const BedBathFilterRef = useRef()
  useOnClickOutside(BedBathFilterRef, e => clickOutsideCallback(e))
  const [values, setValues] = useState({ ...value })

  const updateFilters = newFilter => {
    setValues({ ...values, ...newFilter })
  }

  const { bedroom_count, bathroom_count } = values

  return (
    <div ref={BedBathFilterRef}>
      <StyledFilterWrapper isExt={isExt}>
        <Box
          display="flex"
          flexDirection="column"
          padding="small"
          style={{ gap: '24px', minWidth: '370px' }}
        >
          <Box display="flex" justifyContent="spaceBetween">
            <Label type="medium">
              {t('filters:b.listing_filter.edit.bedroom.label', 'Bedrooms')}
            </Label>
            <ButtonIcon
              icon={<IconClose />}
              onClick={close}
              variant="transparent"
              tone="secondary"
            />
          </Box>
          <BedRadioBar
            t={t}
            bedroom_count={bedroom_count}
            updateFilters={updateFilters}
            disabled={disableBed}
          />
          <Label type="medium">
            {t('filters:b.listing_filter.edit.bathrooms.label', 'Bathrooms')}
          </Label>
          <BathRadioBar
            bathroom_count={bathroom_count}
            updateFilters={updateFilters}
          />
        </Box>
        <Box
          display="flex"
          justifyContent="spaceBetween"
          padding="small"
          background="neutralSoft"
          borderTop="borderNeutralLight"
        >
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button
              variant="transparent"
              size="small"
              onClick={() =>
                updateFilters({ bedroom_count: [], bathroom_count: [] })
              }
            >
              {t('Clear')}
            </Button>
          </Box>
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button
              onClick={() => onChange({ bedroom_count, bathroom_count })}
              size="small"
            >
              {t('common.save', 'Save')}
            </Button>
          </Box>
        </Box>
      </StyledFilterWrapper>
    </div>
  )
}

export default BedBathFilter
